export function isBetweenDate(dateCheck, dateFrom, dateTo): boolean {
    if (!!dateFrom && dateFrom > dateCheck) {
        return false;
    }
    if (!!dateTo && dateTo < dateCheck) {
        return false;
    }
    return true;
}
